import { computePercent as computePercent$1, clamp, percentToValue, snapClamp } from '../../utils/math.js';
import { vec, fromClientXYRelative } from '../../utils/vector.js';

/** Resolve a `number | Vector` prop into a `Vector`. */
function resolveVector(value) {
    if (typeof value === 'number')
        return cachedVec(value, value);
    return cachedVec(value.x, value.y);
}
/** Compute a percent (0–1) for each axis. */
function computePercent(value, min, max) {
    return vec(computePercent$1(value.x, min.x, max.x), computePercent$1(value.y, min.y, max.y));
}
/** Convert a percent (0–1) on each axis back to a value, snapped to step. */
function computeValue(percent, min, max, step) {
    return vec(snapClamp(percentToValue(percent.x, min.x, max.x), step.x, min.x, max.x), snapClamp(percentToValue(percent.y, min.y, max.y), step.y, min.y, max.y));
}
/** Convert a percent (0–1) on each axis back to a value, clamped but not snapped. */
function computeValueRaw(percent, min, max) {
    return vec(clamp(percentToValue(percent.x, min.x, max.x), min.x, max.x), clamp(percentToValue(percent.y, min.y, max.y), min.y, max.y));
}
/** Compute the percent from a pointer event relative to a cached area rect. */
function computePercentFromRect(e, rect) {
    const { x, y } = fromClientXYRelative(e, rect);
    return vec(clamp(x / rect.width, 0, 1), clamp(y / rect.height, 0, 1));
}
/** Cache for Vectors to keep useMemo calls stable.  */
const vectorCache = new Map();
function cachedVec(x, y) {
    let yMap = vectorCache.get(x);
    if (!yMap) {
        yMap = new Map();
        vectorCache.set(x, yMap);
    }
    let cached = yMap.get(y);
    if (!cached) {
        cached = vec(x, y);
        yMap.set(y, cached);
    }
    return cached;
}

export { computePercent, computePercentFromRect, computeValue, computeValueRaw, resolveVector };
//# sourceMappingURL=slider-2d-primitive.utils.js.map
